import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { MainLayout } from 'layouts/MainLayout';
import { LocationCardsWrapper } from 'components/location/cards/LocationCardsWrapper';
import { locationApi } from 'components/location/LocationApi';
import { LOCATIONS } from 'config/routes';
import { Throbber } from 'ui/Throbber';

// FIXME: add loading and error handling
export default () => {
    const navigate = useNavigate();
    const [currentLocation, setCurrentLocation] = React.useState(null);
    const { locationId } = useParams<{ locationId: string }>();
    React.useEffect(() => {
        async function load() {
            const response = await locationApi.get(locationId, {
                queryParameters: [
                    {
                        key: 'expand',
                        value: 'zones'
                    }
                ]
            });
            if (response.ok) {
                setCurrentLocation(response.body);
            }
            if (response.statusCode === 404) {
                navigate(LOCATIONS, { replace: true });
            }
        }
        load();
    }, [navigate, locationId]);
    if (!locationId) {
        return <Navigate to={LOCATIONS} replace />;
    }
    // TODO: add skeleton
    if (!currentLocation) {
        return <Throbber />;
    }
    return (
        <MainLayout
            breadcrumbs={[{ label: 'Locations', url: LOCATIONS }]}
            pageName={currentLocation.title}
            pageDescription="Location details"
        >
            {currentLocation && (
                <LocationCardsWrapper location={currentLocation} setCurrentLocation={setCurrentLocation} />
            )}
        </MainLayout>
    );
};
